export default class PointOnGeometryLocator {
  locate(p) {}
}
